module.exports = __webpack_public_path__ + "img/ninja.05d2cc66.png";